/**
 * navActive - which sidebar item the current URL belongs to.
 *
 * THE BUG THIS REPLACES: the expanded rows matched with a bare
 * `pathname.startsWith(to)` and the collapsed rows with `pathname === to`.
 * Collapsed, that meant EVERY detail page - `/matters/{id}`, `/reviews/{id}`,
 * `/data-sources/{uuid}`, `/tasks/{id}` - dropped the selected mark the moment
 * you opened a record. Expanded, `startsWith` marked the right item most of the
 * time but by accident: it has no segment boundary, so a future `/task` route
 * would light up `/tasks`, and an item whose path were `/` would light up the
 * entire app.
 *
 * THE RULE, one for both densities: an item is active when the pathname IS its
 * path, or continues it AT A SEGMENT BOUNDARY (`to + '/'`). `/data-sources`
 * therefore owns `/data-sources/{uuid}` but not `/data-sources-archive`, and a
 * root path `/` only ever matches `/` itself.
 *
 * Because the boundary must be cleared, nesting stays unambiguous: on
 * `/tasks/123` only `/tasks` matches, and were a `/tasks/board` item ever added
 * it would be the only match on its own route.
 *
 * ITS OWN MODULE so the rule can be pinned by tests without pulling
 * `Sidebar.tsx` - and with it Auth0, the store and the PubSub services - into
 * a unit test.
 */

/** `pathname` (no query, no hash - react-router's `location.pathname`) vs a menu path. */
export const isNavItemActive = (pathname: string, to: string): boolean => {
  // `#` is the menu's "opens a panel, not a route" placeholder (Notifications).
  if (!to || to === '#') return false;

  // Trailing slashes are cosmetic on both sides; compare without them.
  const target = to.replace(/\/+$/, '');
  const current = (pathname || '').replace(/\/+$/, '');

  // A root item is exact-only - otherwise it matches every route in the app.
  if (target === '') return current === '';

  return current === target || current.startsWith(`${target}/`);
};

export default isNavItemActive;
